import { Container } from "@material-ui/core";
import { Helmet } from "react-helmet";

import { Generator } from "../../../../components/Generator";
import { Grid } from "../../../../components/Grid";
import { Heading } from "../../../../components/Heading";
import { Sidebar } from "../../../../components/Navigation/Sidebar";
import { FormType } from "../../../../components/enums";
import {
  usePreventRefresh,
  useScrollDocument,
  useShouldRedirectToHomepage,
  useShowFooter,
  useTitle,
} from "../../../../hooks";
import { Url } from "../../../../router/enums";
import { selectIsFormValidated } from "../../../Welcome/welcome.selectors";

import styles from "./Introductory.module.scss";
import { applicantDataForm, perpetratorDataForm } from "./form";

export const Introductory = (): JSX.Element => {
  // useShouldRedirectToHomepage(selectIsFormValidated);
  useShowFooter();
  useScrollDocument();
  useTitle("Ayvens OC");
  usePreventRefresh();

  return (
    <Container className={styles.container}>
      <Heading component="h1" variant="h1" spacingBottom={4}>
        Zgłoś szkodę z OC sprawcy
      </Heading>

      <Grid
        container
        alignItems="flex-start"
        className={styles.page}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        direction="row"
      >
        <Sidebar
          currentRoute={Url.OC_VEHICLE_INTRODUCTORY}
          type={FormType.OC_VEHICLE}
        />

        <Helmet>
          <script
            // 1) absolutna ścieżka z PUBLIC_URL (działa w dev i prod)
            src={`${process.env.PUBLIC_URL}/LPPL_Scripts/SaveApplicantDataToStorage.js`}
            type="text/javascript"
            defer
          />
        </Helmet>

        <Generator
          form={[perpetratorDataForm, applicantDataForm]}
          render={(generatedForm) => (
            <Grid item xs={12} md={8}>
              {generatedForm}
            </Grid>
          )}
        />
      </Grid>
    </Container>
  );
};
